export const EnforcePaymentHistoryTable = 'ARF-949-enforce-update-payment-history-table';
export const TnCOffices = 'TEMP-15427-tnc-offices';
export const ShowAchAuthorizationPopup = 'show-ach-authorization-popup';
export const EnablePermSessionRecording = 'ARF-1725-enable-perm-session-recording-dental-portal';
export const EnableSignUpSessionRecording =
  'TEMP-16399-enable-signup-session-recording-dental-portal';
export const EnableShiftRequestSessionRecording =
  'GOTU-6951-enable-shift-request-session-recording-dental-portal';
export const ProfessionalHubRedesign = 'TEMP-15781-Dental-New-to-You-Redesign';
export const CredentialingV2 = 'TEMP-13770-credentialing-v2';
export const CredentialingV2DNTApi = 'GOTU-2547-credentialing-v2-dnt-api';
export const TurnstileLoginEnabled = 'turnstile-login-enabled';
export const HideRequestReportButton = 'TEMP-13338-hide-request-report-button';
export const DomainDecommissioning = 'TEMP-13485-domain-decommissioning';
export const EnforcePromoCode = 'ARF-2092-promo-codes';
export const AutoNavigateActionNeeded = 'GOTU-3821-auto-navigate-action-needed';
export const ShiftRequestRateFriction = 'GOTU-3866-shift-request-rate-friction';
export const ReadOfficeDetailFromOrgService = 'GOTU-4961-dental-portal-office-read';
export const SdbEnhancedRate = 'GOTU-972-sdb-enhanced-rate';
export const SortInviteListsByAvailability = 'GOTU-4327-sort-invite-lists-by-availability';
export const SaltclickChatbot = 'GOTU-4448-saltclick-chatbot';
export const BestInDentalV2 = 'GOTU-5623-best-in-dental-web';
export const ShiftDetailsInviteSection = 'GOTU-5384-shift-details-invite-section';
export const LastMinuteAutoConfirm = 'GOTU-5391-last-minute-auto-confirm';
export const DiscountCodes = 'GOTU-5651-discount-codes-web';
export const ShiftDetailsPageRedesign = 'GOTU-7063-shift-details-redesign-dental-portal';
/**
 * Release switch for the rebuilt referral programme (GOTU-6523). Deliberately
 * the same key mobile reads, not a `-dental-portal` twin: the two clients post
 * the same `referredByCode` to the same auth-service and must flip together.
 */
export const ReferralProgramRebuild = 'GOTU-6523-referral-program-rebuild';
/**
 * Epic-level gate for the milestone-2 office-side updates (GOTU-8153), including
 * the postings index (GOTU-6763). Deliberately the same key mobile reads, not a
 * `-web` twin: the ticket names one key for both surfaces and GOTU-8253 removes it.
 */
export const DebOfficeUpdates = 'GOTU-8153-deb-office-updates';
/**
 * Release switch for NPS moving to auth-service (GOTU-7479). On: the answer and
 * the "show the NPS screen now?" question go to auth-service. Off: the monolith's
 * POST /nps-review and `user.show_nps`, unchanged. The ticket names this one
 * epic-level key, not a `-web` twin; GOTU-16478 removes it.
 */
export const NpsIdentity = 'GOTU-7479-nps-identity';
/**
 * Missing office-info modal in the shift request flow, and # operatories becoming required in
 * Account Information (GOTU-9592 / GOTU-12579). The story has no epic, so the key uses its number.
 */
export const OfficeInfoCollection = 'GOTU-9592-office-info-collection-web';
/**
 * Splits the office Account area into Location settings (`/locations`) and My
 * profile (`/my-profile`) (GOTU-15553, epic GOTU-7475). Off: today's `/account`.
 * On: `/account` and `/account/information` redirect to `/locations`. The mobile
 * twin is `GOTU-7475-account-split-mobile`.
 */
export const AccountSplitWeb = 'GOTU-7475-account-split-web';
/**
 * Worker type and PSA rules (GOTU-7481, epic GOTU-7475). On: a parent that picks a child in the
 * shift request's Office field is asked for that child's Personnel Service Agreement before it
 * posts, and a Worker Type save reads the office's latest request, not its first, to decide between
 * "Pending Approval" and "Successfully Selected". Off: the PSA is asked only once a post is refused,
 * and the save reads the first request.
 */
export const WorkerTypePsaWeb = 'GOTU-7475-worker-type-psa-web';
/** No `-web` suffix on purpose: mobile and admin read this key too, so an office sees one arm. */
export const LikelyToFillIndicator = 'GOTU-13065-likely-to-fill-indicator';
/**
 * A/B test of the standard office cancel flow (GOTU-15983): `control` keeps today's flows,
 * `treatment` gets the new one. Render with the peek read (`useStandardCancelFlow`); record the
 * exposure (`getStandardCancelFlow`) only when the office starts a cancel. Mobile twin:
 * `GOTU-15984-standard-cancel-flow-mobile`. Cleanup: GOTU-19308.
 */
export const StandardCancelFlow = 'GOTU-15983-standard-cancel-flow-dental-portal';
